import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="bg-alert px-5 py-14" data-id="element-216" data-mp="2bwe6imbbrd3g">
      <div className="mx-auto max-w-2xl text-center" data-id="element-217" data-mp="2bvcrk6r6u6gg">
        <p className="text-xs font-black uppercase tracking-[0.2em] text-white/80" data-id="element-218" data-mp="1wznfb0bt17ox">
          ⏰ Limited-Time Offer
        </p>
        <h2 className="mt-3 font-display text-2xl font-black text-white sm:text-3xl" data-id="element-219" data-mp="21xgm9vkxm5q9">
          Launch Price Ends In:
        </h2>

        <div className="mt-7" data-id="element-220" data-mp="1o5sbpwqbzpbe">
          <Countdown tone="light" size="lg" data-id="element-221" data-mp="1sxtlnc0113y9" />
        </div>

        <p className="mt-6 text-sm text-white/85" data-id="element-222" data-mp="1szd2b3plhh0k">
          After that, the price goes up and bonuses are removed.
        </p>

        <div className="mx-auto mt-9 max-w-md rounded-xl bg-black/25 px-5 py-5" data-id="element-223" data-mp="1e72tg2uiw2um">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-white" data-id="element-224" data-mp="1j5w6ju5wdru9">
            🔴 Limited spots — 72% claimed
          </p>
          <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-white/25" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Spots claimed" data-id="element-225" data-mp="19acc7c6zf17m">
            <div className="h-full w-[72%] rounded-full bg-white" data-id="element-226" data-mp="212jyk8gffzbx" />
          </div>
        </div>
      </div>
    </section>;
}